import { Editable as Native, IconButton } from "@chakra-ui/react"
import { Form } from "components"
import { LuCheck, LuPencilLine, LuX } from "react-icons/lu"

export default function Editable({ previewProps = {}, ...props }){
  return (
    <Form.Field {...props}>
        <Native.Root {...props}>
        <Native.Preview {...previewProps} />
        <Native.Input />
        <Native.Control>
            <Native.EditTrigger asChild>
            <IconButton variant="ghost" size="xs">
                <LuPencilLine />
            </IconButton>
            </Native.EditTrigger>
            <Native.CancelTrigger asChild>
            <IconButton variant="outline" size="xs">
                <LuX />
            </IconButton>
            </Native.CancelTrigger>
            <Native.SubmitTrigger asChild>
            <IconButton variant="outline" size="xs">
                <LuCheck />
            </IconButton>
            </Native.SubmitTrigger>
        </Native.Control>
        </Native.Root>
    </Form.Field>
  )
}
